import type { Option } from '@mylighthouse/prism-ember/types/components/prism/select-input';
import { tKey } from 'ember-intl';
import type { ComparisonSetWithoutOwn } from 'frontend-utils/utils/constants/benchmark-insight';

export const DROPDOWN_COMPARISON_SETS_OPTION_NONE = 'none';

export const DROPDOWN_COMPARISON_SETS_OPTION_NONE_TRANSLATION = tKey(
  'benchmark_insight.data_set_selection.no_secondary_data_set',
);

export type DropdownComparisonSetsOptionNone =
  typeof DROPDOWN_COMPARISON_SETS_OPTION_NONE;

export type DropdownPrimaryComparisonSetOption = Option & {
  id: ComparisonSetWithoutOwn;
};

export type DropdownSecondaryComparisonSetOption = Option & {
  id: ComparisonSetWithoutOwn | DropdownComparisonSetsOptionNone;
};
